import { Cascader } from 'antd';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { notifyError } from '../store/utils';
import { API } from '../api';

interface AddressCascaderProps {
  value?: string[];
  disabled?: boolean;
  onChange?: (value: (string | number | null)[]) => void;
}

const AddressZipcodeCascader: React.FC<AddressCascaderProps> = ({ value, disabled, onChange }) => {
  const [state, updateState] = useState<any[]>([]);

  const fetchFullAddress = useCallback(async () => {
    try {
      const { result } = await API.get({ apiVersion: 'api' })(`/common/address`);
      updateState(result || []);
    } catch (error: any) {
      notifyError(error.message);
    }
  }, []);

  useEffect(() => {
    fetchFullAddress();
  }, []);

  const options = useMemo(() => {
    const items = state.map((item: any) => {
      return {
        value: item.zipcode,
        label: item.name,
        children: (item.districts || []).map((district: any) => {
          return {
            value: district.zipcode,
            label: district.name,
            children: (district.streets || []).map((street: any) => {
              return {
                value: street.zipcode,
                label:
                  (street.description ? `${street.description}, ${street.name}` : street.name) +
                  ' ' +
                  street.zipcode,
              };
            }),
          };
        }),
      };
    });
    return items;
  }, [state]);

  return (
    <Cascader showSearch options={options} value={value} disabled={disabled} onChange={onChange} />
  );
};

export default AddressZipcodeCascader;
